export const CONTACT_TEXT = {
  title: "Contact",
  nameLabel: "Name",
  emailLabel: "Email",
  messageLabel: "Message",
  submit: "Send",
  success: "Message sent (demo).",
  invalidEmail: "Please enter a valid email.",
  required: "This field is required.",
  subtitle:
    "We would love to hear from you. Please fill out the form below to get in touch with us.",
} as const;
